import { memoize } from 'lodash';

export const queryWideEls = () => {
  return [...document.querySelectorAll('.js-wide-block')];
};

export const withYOffset = (value) => {
  return pageYOffset + value;
};

export const getBoundingClientRect = (el) => {
  return el.getBoundingClientRect();
};

// Возвращает функцию, которая кэширует результат ф-ии queryWideEls
export const getCachedWideEls = memoize(queryWideEls);

/**
 * Получает JSON партнерских блоков
 *
 * @param userUid {String} - уникальный токен пользователя
 * @param blocksIds {String} - строка с числами разделенные запятой
 *
 * @returns {Promise}
 */
export const getPartnersBlocksJSON = function(userUid, blockIds) {
  const url = `https://api.rnet.plus/service/blocks?ids=${blockIds}&user_id=${userUid}`;
  const width = window.screen.width;
  const height = window.screen.height;
  return new Promise((resolve) => {
    $.getJSON(url + `${width} + x + ${height}`, (response) => {
      resolve(response);
    });
  });
};

/**
 * generateUserUuid - генерирует
 * уникальный токен пользователя
 * @returns {String}
 */
export const generateUserUuid = function() {
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
    // eslint-disable-next-line
    const r = Math.random() * 16 | 0, v = c === 'x' ? r : (r & 0x3 | 0x8);
    return v.toString(16);
  });
};

/**
 * getOrCreateUuid - создает или возвращает уникальный
 * идентификатор пользователя
 *
 * @returns {String}
 */
export const getOrCreateUuid = function() {
  const keyName = 'RamblerExchangeUserId';
  let uuid;
  if (window.localStorage) {
    uuid = localStorage.getItem(keyName);
    if (!uuid) {
      uuid = generateUserUuid();
      localStorage.setItem(keyName, uuid);
    }
  }
  return uuid;
};

/**
 * isScrolledIntoView - проверяет находится ли элемент внутри вьюпорта
 *
 * @param elem - {Object} domNode
 * @returns {Boolean}
 */
export function isScrolledIntoView(elem) {
  const docViewTop = $(window).scrollTop();
  const docViewBottom = docViewTop + $(window).height();
  const elemTop = $(elem).offset().top;
  const elemBottom = elemTop + $(elem).height();
  const elemLeft = $(elem).offset().left;
  const style = getComputedStyle(elem);
  const visibility = style.visibility;
  const display = style.display;
  const noSize = !$(elem).height() || !$(elem).width();
  const isNotVisible = visibility === 'hidden' || display === 'none' || noSize
    || elemLeft < 0 || elemLeft > $(window).width();
  if (isNotVisible) return false;
  return (
    (elemBottom <= docViewBottom) && (elemTop >= docViewTop) ||
    (elemBottom >= docViewBottom) && (elemTop <= docViewTop)
  );
}

export const resolve = (path, obj, separator) => {
  const self = this;
  return path.split(separator).reduce(function(prev, curr) {
    return prev ? prev[curr] : null;
  }, obj || self);
};

/**
 * Проверяет наезжает ли визуально элемент на любой элемент из списка
 *
 * @param el {Object} domNode - проверяемый элемент
 * @param els {Array} domNodeLists - список элементов
 * @param addSpaceVal {Number} - Дополнительное пространство
 * @param addSpaceStepVal {Number} - Значение каждого шага в доп.пространстве
 *
 * @returns {Boolean}
 */
export const checkOverlaps = (el, els, addSpaceVal = 100, addSpaceStepVal = 10) => {
  if(!el) return false;
  const rect = el.getBoundingClientRect();
  let overlaps = false;
  const top = withYOffset(rect.top);
  const bottom = withYOffset(rect.bottom);
  els.forEach((wideEl) => {
    const wideElRect = wideEl.getBoundingClientRect();
    let additionalSpace = 0;
    while (additionalSpace <= addSpaceVal) {
      const wideBottom = withYOffset(wideElRect.bottom) + additionalSpace;
      const wideTop = withYOffset(wideElRect.top) - additionalSpace;

      const topInWide = top > wideTop && top < wideBottom;
      const bottomInWide = bottom > wideTop && bottom < wideBottom;

      if (topInWide || bottomInWide) {
        overlaps = true;
      }

      additionalSpace += addSpaceStepVal;
    }
  });
  return overlaps;
};

/**
 * Находит предыдущие и следующие элементы
 * в зависимости от текущего положения el
 *
 * @param el {Object} - domNode
 * @param els {Array} - list of domNodes
 *
 * @returns {Object}
 */
export const findPreviusAndNextWideEls = (el, list) => {
  const rects = list.map(getBoundingClientRect);
  const rect = el.getBoundingClientRect();
  const els = {
    previus: {
      el: null,
      rect: null
    },
    next: {
      el: null,
      rect: null
    }
  };

  const count = rects && rects.length > 0;
  let search = true;
  let i = 0;

  while (count && search) {
    let wideRect = rects[i];
    let currentEl = list[i];
    if (withYOffset(rect.bottom) < withYOffset(wideRect.top)) {
      els.previus = {
        el: currentEl,
        rect: wideRect
      };
    }
    if (withYOffset(rect.top) < withYOffset(wideRect.top)) {
      els.next = {
        el: currentEl,
        rect: wideRect
      };
    }
    if (!(els.next.el && els.previus.el)) {
      i++;
    } else {
      search = false;
    }
  }
  return els;
};

/**
 * A simple memoize function that takes in a function and returns a memoized function
 * @param  {Function} fn - function to cache
 * @return {Function} fn - wrapped function
 */
export const memoizeSimple = (fn) => {
  let cache = {};
  return (...args) => {
    let n = args[0];  // just taking one argument here
    // return from cache
    if (n in cache) {
      return cache[n];
    }
    // return calc result
    let result = fn(n);
    cache[n] = result;
    return result;
  };
};

/**
 * Возвращает тип страницы ('main - главная' | 'article - статья' | 'news - новость')
 * @return {String}
 */
export const getPageType = function() {
  let pageType = '';
  if (window.location.pathname === '/') {
    pageType = 'main';
  } else if (document.querySelector('.js-article')) {
    pageType = 'article';
  } else if (document.querySelector('.js-news')) {
    pageType = 'news';
  }
  // Если тип страницы не удалось определить
  if (pageType === '') {
    // Вернем активную рубрику
    pageType = getSelectedRubrique();
  }
  // Если рубрику не удалось определить
  if (pageType === '') {
    // Вернем pathname из location
    pageType = window.location.pathname.replace(/\/*/g, '');
  }
  return pageType;
};

export const getSelectedRubrique = function(el) {
  const element = el || document.querySelector('.js-headline a.is-active');
  const val = element && element.getAttribute('href').replace(/\/*/g, '');
  if (!val && window.location.pathname === '/') {
    return '';
  }
  return val;
};

export const getMaterialName = function() {
  const title = document.querySelector('h1') || document.querySelector('[itemprop=headline]');
  const name = title && title.innerText;
  if (!title || !name && window.location.pathname === '/') {
    return '';
  }
  return name;
};

export const getElementIDWithType = function(el) {
  return el.getAttribute('data-id') || el.getAttribute('data-recomm-id');
};

/**
 * Хелпер для создания простого поведения выпадающего меню
 * Добавит на элемент с классом menuButtonClass eventListener который будет тогглить
 * класс .is-open на элементе с классом menuClass. Добавляет общий для всех меню обработчик клика
 * на document.body который закрывает меню при клике вне тела меню.
 * @param menuButtonClass: String - класс элемента кнопки, по нажатии которой будет открываться меню
 * @param menuClass: String - класс элмента тела меню
 * @param container: Element - контейнер, в котором искать элементы, необязательный параметр
 */
export const setDropdownBehavior = function(menuButtonClass, menuClass, container) {
  let isMenuOpen = false;

  const button = container ? container.querySelector(menuButtonClass) : document.querySelector(menuButtonClass);
  const menu = container ? container.querySelector(menuClass) : document.querySelector(menuClass);

  const menuCloseFn = () => {
    document.body.removeEventListener('click', menuCloseFn, false);
    menu.classList.remove('is-open');
    button.classList.remove('is-open');
    isMenuOpen = false;
  };

  if (button && menu) {
    button.addEventListener('click', (e) => {
      e.stopPropagation();
      button.classList.toggle('is-open');
      menu.classList.toggle('is-open');
      if (isMenuOpen) {
        document.body.removeEventListener('click', menuCloseFn, false);
        isMenuOpen = false;
      } else {
        document.body.addEventListener('click', menuCloseFn);
        isMenuOpen = true;
      }
    });
  }
};

export function copyToClipboard(text) {
  const elem = document.createElement('textarea');
  elem.value = text;
  elem.setAttribute('readonly', '');
  elem.style.position = 'absolute';
  elem.style.left = '-9999px';
  elem.style.opacity = 0;
  elem.style.height = 0;
  document.body.appendChild(elem);
  elem.select();
  document.execCommand('copy');
  document.body.removeChild(elem);
}



// WEBPACK FOOTER //
// ./daily/assets/javascripts/utils/common.js